import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, CircularProgress } from '@material-ui/core';
import "./Breakdown.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import PowerIcon from '@material-ui/icons/Power';
import { attendBreakDown, getBDStatus, getBreakdowns, getUserReadable } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';

const TodayBreakdown = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
    ];
    const [loading, setLoading] = useState(true);
    const [isAttendingBreakdown, setIsAttendingBreakdown] = useState(false);
    const [BDStatus, setBDStatus] = useState();
    const [breakDowns, setBreakdowns] = useState([]);
    const [userId, setUserId] = useState();
    const Role = localStorage.getItem("userRole");

    const getPriorityClass = (priority) => {
        switch (priority.toLowerCase()) {
            case 'high':
                return 'high-priority';
            case 'medium':
                return 'medium-priority';
            case 'low':
                return 'low-priority';
            default:
                return '';
        }
    };

    const isToday = (dateString) => {
        const reportedDate = new Date(dateString);
        const today = new Date();

        return reportedDate.getDate() === today.getDate() &&
            reportedDate.getMonth() === today.getMonth() &&
            reportedDate.getFullYear() === today.getFullYear();
    };

    const todaysBreakdowns = breakDowns && breakDowns.filter(item => isToday(item.reported_at));

    // Get today's date in YYYY-MM-DD format
    // const today = new Date().toISOString().split('T')[0];
    // const reports = JSON.parse(localStorage.getItem("report")) || [];
    // // Filter reports to include only those with today's date
    // const todayReports = reports.filter(report => report.date === today);
    // console.log("Today's reports:", todayReports);
    // console.log("reports:", reports);

    // const handler = (asset) => {
    //     navigate(`/attend-breakdown/${asset.assetNo}/${asset.id}`)
    // }

    const handler = async (asset) => {
        if (Role === 'admin' || Role === 'supplier') {
            if (asset.status === "reported") {
                setIsAttendingBreakdown(true);
                const payload = {
                    machine_breakdown_id: asset.id,
                    status_id: BDStatus,
                    observation: "Attended",
                    customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                    approvers: [{
                        approval_user: userId
                    }]

                }
                console.log("payload:", payload)
                try {
                    const action = dispatch(attendBreakDown(payload));
                    const res = await action.unwrap();
                    console.log("res", res.result)
                    if (res.result) {
                        setIsAttendingBreakdown(false);
                        toast.success("BreakDown Attended Successfully!");
                        navigate(`/attend-breakdown/${asset.assetNo}/${asset.id}`)
                    }
                } catch (error) {
                    setIsAttendingBreakdown(false);
                    console.error("Error in okHandler:", error);
                    toast.error(error.message || "Something went wrong!");
                }
            } else {
                navigate(`/attend-breakdown/${asset.assetNo}/${asset.id}`)

            }
        } else {
            toast.info("You don't have access to do this activity!")
        }



    }

    const getBreakDowns = async (id) => {
        try {
            const action = dispatch(getBreakdowns(`?status_id=${id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdowns(prevBreakDowns => [...prevBreakDowns, ...res.result.breakdowns]);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            // toast.error(error.message || "Something went wrong!");
        }
    };

    const getStatus = async () => {
        try {
            const action = dispatch(getBDStatus());
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {

                // Find the id for status "reported"
                const reportStatus = res.result.bd_status.find(item => item.status === "reported");
                const reportStatusId = reportStatus ? reportStatus.id : null;

                // Find the id for status "under-maintenance"
                const mainStatus = res.result.bd_status.find(item => item.status === "under-maintenance");
                const mainStatusId = mainStatus ? mainStatus.id : null;
                setBDStatus(mainStatusId)

                if (reportStatusId) {
                    await getBreakDowns(reportStatusId)
                    await getBreakDowns(mainStatusId)
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const UserReadeable = async () => {
        try {
            const action = dispatch(getUserReadable());
            const res = await action.unwrap();
            console.log("res", res.result.user.customerId)
            if (res.result) {
                setUserId(res.result.user.id)


            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }



    useEffect(() => {
        let isMounted = true;  // Track if the component is still mounted

        const fetchData = async () => {
            try {
                await getStatus();
                await UserReadeable();
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        // Cleanup function to prevent state update on unmounted component
        return () => {
            isMounted = false;
        };
    }, []);



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Today's Breakdown" />
                </Box>
                {/* <Box mb={2}>
                    {todayReports.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <PowerIcon style={{ fontSize: 40, marginRight: 8 }} />
                            <Typography variant="h5">No Breakdown today</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={4}>
                            {todayReports.map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={index} onClick={() => handler(item)}>
                                    <div className='breakdown-card'>
                                        <div className={`card-header ${getPriorityClass(item.priority)}`}>
                                            <span>
                                                <PowerIcon />
                                            </span>
                                            {item.assetDescription} ({item.assetNo})
                                        </div>
                                        <h4>{item.assetDescription}</h4>
                                        <p>Category: {item.nature}</p>
                                        <p>Reason: {item.reason}</p>
                                        <p>Priority: {item.priority}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Box> */}
                {isAttendingBreakdown ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100vh"
                        position="fixed"
                        top="0"
                        left="0"
                        width="100%"
                    // bgcolor="rgba(0, 0, 0, 0.5)"
                    >
                        <Box display="flex" alignItems="center" flexDirection="row" gap={3}>
                            {/* <CircularProgress /> */}
                            <Typography variant="h4">
                                Attending Breakdown...
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    <Box mb={2}>
                        {todaysBreakdowns.length === 0 ? (
                            <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                                <PowerIcon style={{ fontSize: 40, marginRight: 8 }} />
                                <Typography variant="h5">No Breakdowns Today</Typography>
                            </Box>
                        ) : (<Grid container spacing={4}>
                            {todaysBreakdowns
                                .map((item, index) => (
                                    <Grid item xs={12} sm={3} key={index} onClick={() => handler(item)}>
                                        <div className='breakdown-card'>
                                            <div className={`card-header ${getPriorityClass(item.priority)}`}>
                                                <span>
                                                    <PowerIcon />
                                                </span>
                                                {item.machine_details.asset_text} ({(item.machine_details.asset_no).slice(3)})
                                            </div>
                                            <h4>{item.machine_details.asset_text}</h4>
                                            <p><span>Category:</span> {item.reason.category_name}</p>
                                            <p><span>Reason:</span> {item.reason.name}</p>
                                            <p><span>Priority:</span> {item.priority}</p>
                                            <p><span>Status:</span> {item.status}</p>
                                            <p><span>Reported by:</span> {item.reported_by}</p>
                                            <p><span>Reported at:</span> {convertUTCtoIST(item.reported_at)}</p>
                                            {item.attended_by && (
                                                <p><span>Attended by:</span> {item.attended_by}</p>
                                            )}
                                        </div>
                                    </Grid>
                                ))}
                        </Grid>)}

                    </Box>
                )
                }
            </Container>
            <ToastContainer />
        </Layout >
    );
};

export default TodayBreakdown;
